import type { ReactNode } from 'react';
import type { HelpLinkedTextProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

// Cuts the text at the backend's link offsets; allowed links become buttons.
const HelpLinkedText = ({ text, links, onNavigate }: HelpLinkedTextProps) => {
  if (!links?.length) return <>{text}</>;

  const parts: ReactNode[] = [];
  let cursor = 0;

  [...links]
    .sort((a, b) => a.start - b.start)
    .forEach((link) => {
      // Skip overlapping or out-of-range offsets instead of breaking the text.
      if (link.start < cursor || link.end > text.length) return;

      parts.push(text.slice(cursor, link.start));
      const label = text.slice(link.start, link.end);

      parts.push(
        link.allowed ? (
          <button
            key={link.start}
            type='button'
            className={styles.articlePathLink}
            onClick={() => onNavigate(link)}
          >
            {label}
          </button>
        ) : (
          label
        )
      );
      cursor = link.end;
    });

  parts.push(text.slice(cursor));
  return <>{parts}</>;
};

export default HelpLinkedText;
